module.exports = __webpack_public_path__ + "img/手机端商品SKU.96e80bd4.png";